export default __webpack_public_path__ + "static/media/fluxxor.97e03a25.svg";